import React from 'react';
import { classNames } from '../atoms';

interface BottomNavProps extends React.HTMLAttributes<HTMLElement> {}

const BottomNav: React.FC<BottomNavProps> = ({ className, children, ...props }) => (
  <footer
    className={classNames('app-footer-nav bg-primary text-white shadow-lg', className)}
    {...props}
  >
    {children}
  </footer>
);

export default BottomNav;
